var module = angular.module('main.customerinvoice');

module.component('caCustomerInvoiceSearch',{
    templateUrl: 'main/customerinvoice/customerinvoicesearch/customerinvoicecontent/customerinvoicesearch.cmp.tpl.html',
    bindings: {
        searchTerm: '<',
        onCustomerInvoiceSelected: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($rootScope, $scope, $state, $stateParams, $translate, CustomerInvoiceApiService,
    loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.loadCustomerInvoices = loadCustomerInvoices;
    vm.searchTermChange = searchTermChange;
    vm.resetFilters = resetFilters;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getTypeTranslation = getTypeTranslation;
    vm.selectInvoice = selectInvoice;

    activate();

    function onInit() {
        vm.customerInvoices = [];
        vm.searchTerm = {};
        vm.searchTerm.term =  ($stateParams.searchTerm) ? $stateParams.searchTerm : '';
        vm.searchTerm.dueDateMin = new Date();
        vm.searchTerm.dueDateMax = new Date();
        vm.searchTerm.invoiceDateMin = new Date();
        vm.searchTerm.invoiceDateMax = new Date();
        vm.searchTerm.invoiceTypes = [];

        vm.dueDate = '';
        vm.invoiceDate = '';
        vm.dueMinStartDate = new Date();
        vm.dueMinEndDate = new Date();
        vm.dueMinStartDate = new Date();
        vm.dueMinEndDate = new Date();
        vm.invoiceMinEndDate = new Date(2020, 1, 1);
        vm.invoiceMaxEndDate = new Date(2020, 1, 1);

        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.itemsPerPage = 15;
    }
    function onChanges() {
    }

    function activate() {
        loadCustomerInvoices();
        $scope.$watch(function () {
            return vm.searchTerm.dueDateMin + vm.searchTerm.dueDateMax + vm.searchTerm.invoiceDateMin + vm.searchTerm.invoiceDateMax;
        }, function (oldValue, newValue) {
            if (oldValue !== newValue) {
                searchTermChange();
            }
        });
    }

    function loadCustomerInvoices() {
        loadSpinnerService.start('mainSpinner');
        CustomerInvoiceApiService.getAll(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function (response) {
            vm.customerInvoices = response.data;
            vm.totalItems = response.totalItems;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function selectInvoice(invoiceId) {
        vm.onCustomerInvoiceSelected({ invoiceId: invoiceId });
    }

    function getStatusTranslation(text) {
        return $translate.instant('customerinvoice.status' + text);
    }

    function getTypeTranslation(text) {
        return $translate.instant('customerinvoice.type' + text);
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadCustomerInvoices();
    }

    function resetFilters() {
        vm.searchTerm.dueDateMin = new Date();
        vm.searchTerm.dueDateMax = new Date();
        vm.searchTerm.invoiceDateMin = new Date();
        vm.searchTerm.invoiceDateMax = new Date();
        vm.searchTerm.term = '';
    }
}
